var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXrpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1215 0.85942C19.2281 -0.286473 21.772 -0.286474 23.8786 0.85942L36.0914 7.50256C38.3669 8.74033 39.7834 11.1233 39.7834 13.7137V26.2863C39.7834 28.8767 38.3669 31.2597 36.0914 32.4974L23.8786 39.1406C21.772 40.2865 19.2281 40.2865 17.1215 39.1406L4.9087 32.4974C2.63318 31.2597 1.21667 28.8767 1.21667 26.2863L1.21667 13.7137C1.21667 11.1233 2.63318 8.74033 4.9087 7.50256L17.1215 0.85942Z",
    fill: "#23292F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2103_14872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 36C29.3366 36 36.5 28.8366 36.5 20C36.5 11.1634 29.3366 4 20.5 4C11.6634 4 4.5 11.1634 4.5 20C4.5 28.8366 11.6634 36 20.5 36Z",
    fill: "#23292F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.57 12H30.46L24.445 17.957C23.3934 18.9931 21.9763 19.5739 20.5 19.5739C19.0237 19.5739 17.6066 18.9931 16.555 17.957L10.535 12H13.43L18 16.523C18.6655 17.1799 19.5629 17.5482 20.498 17.5482C21.4331 17.5482 22.3305 17.1799 22.996 16.523L27.57 12ZM13.395 28.563H10.5L16.555 22.57C17.6066 21.5339 19.0237 20.9531 20.5 20.9531C21.9763 20.9531 23.3934 21.5339 24.445 22.57L30.5 28.562H27.605L23 24C22.3345 23.3431 21.4371 22.9748 20.502 22.9748C19.5669 22.9748 18.6695 23.3431 18.004 24L13.394 28.563H13.395Z",
    fill: "#FCFCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2103_14872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4.5 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrpIcon);
export default __webpack_public_path__ + "static/media/xrp-icon.d5b001a91748ecc100bf958b19a33dde.svg";
export { ForwardRef as ReactComponent };